function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.932 2.4v3.813"
}, /*#__PURE__*/React.createElement("animate", {
  attributeType: "CSS",
  attributeName: "opacity",
  values: "1;0",
  begin: "-1s",
  dur: "1s",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("path", {
  d: "M15.973 7.89l2.698-2.697"
}, /*#__PURE__*/React.createElement("animate", {
  attributeType: "CSS",
  attributeName: "opacity",
  values: "1;0",
  begin: "-0.852s",
  dur: "1s",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("path", {
  d: "M17.651 11.932h3.813"
}, /*#__PURE__*/React.createElement("animate", {
  attributeType: "CSS",
  attributeName: "opacity",
  values: "1;0",
  begin: "-0.71s",
  dur: "1s",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("path", {
  d: "M15.973 15.974l2.698 2.697"
}, /*#__PURE__*/React.createElement("animate", {
  attributeType: "CSS",
  attributeName: "opacity",
  values: "1;0",
  begin: "-0.548s",
  dur: "1s",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("path", {
  d: "M11.932 17.65v3.814"
}, /*#__PURE__*/React.createElement("animate", {
  attributeType: "CSS",
  attributeName: "opacity",
  values: "1;0",
  begin: "-0.426s",
  dur: "1s",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("path", {
  d: "M5.193 18.671l2.697-2.697"
}, /*#__PURE__*/React.createElement("animate", {
  attributeType: "CSS",
  attributeName: "opacity",
  values: "1;0",
  begin: "-0.284s",
  dur: "1s",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("path", {
  d: "M2.4 11.932h3.813"
}, /*#__PURE__*/React.createElement("animate", {
  attributeType: "CSS",
  attributeName: "opacity",
  values: "1;0",
  begin: "-0.142s",
  dur: "1s",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("path", {
  d: "M5.193 5.193L7.89 7.89"
}, /*#__PURE__*/React.createElement("animate", {
  attributeType: "CSS",
  attributeName: "opacity",
  values: "1;0",
  begin: "0s",
  dur: "1s",
  repeatCount: "indefinite"
})));

var SvgDocLoad = function SvgDocLoad(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDocLoad, _extends({
    svgRef: ref
  }, props));
});
export default "https://sf16-website.neutral.ttwstatic.com/obj/tiktok_web_static/bytecom/api_gateway_web_i18n/static/media/doc-load.a180f82d.svg";
export { ForwardRef as ReactComponent };